import React from 'react';

const Buyer = ({username, endDate, allowContact, buyerMessage, clickContact}) => (
    <div className="content buyer-view">
        <h3 className="title" dangerouslySetInnerHTML={{ __html: i18n.t('out_of_office.banner.buyer.is_out', {username, endDate}) }}></h3>
        {allowContact && (
            <p className="notice">
                {i18n.t('out_of_office.banner.buyer.meantime')}
                <a href={`/conversations/${username}`} onClick={clickContact}>{i18n.t('out_of_office.banner.buyer.contact')}</a> {username}
            </p>
        )}
        {buyerMessage && buyerMessage.length && <p className="buyer-message">{buyerMessage}</p>}
    </div>
);

export default Buyer;


// WEBPACK FOOTER //
// ./src/ProfileBanner/Buyer.js